import ApiService from "@/_services/api/api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SalesOrderSplitService = {
  async getEligibility(salesOrderCode) {
    return await ApiService.get(
      `api/SalesOrderSplitEligibility?SalesOrderCode=${salesOrderCode}`
    );
  },

  async splitOrder(payload) {
    return await ApiService.post("api/Save_SalesOrderSplit", payload);
  },
};

export { SalesOrderSplitService };
